var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import ButtonContent from './ButtonContent';
import { CleanButton } from './CleanButton';
import { getHorizontalPadding, getHeightStyle, getFontSize, getIconContainerSize } from './buttonSize.style';

var BaseButtonComponent = function BaseButtonComponent(_a) {
  var component = _a.component,
      leftIcon = _a.leftIcon,
      rightIcon = _a.rightIcon,
      children = _a.children,
      other = __rest(_a, ["component", "leftIcon", "rightIcon", "children"]);

  return React.createElement(CleanButton, __assign({
    as: component
  }, other), (children || leftIcon || rightIcon) && React.createElement(ButtonContent, {
    leftIcon: leftIcon,
    rightIcon: rightIcon
  }, children));
};

BaseButtonComponent.defaultProps = {
  children: null,
  component: null,
  leftIcon: null,
  rightIcon: null
};
export var BaseButton = styled(BaseButtonComponent).attrs(function (_a) {
  var size = _a.size,
      iconSize = _a.iconSize;
  return {
    $size: size,
    $iconSize: iconSize
  };
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
  var button = _a.theme.splash.button;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: ", ";\n    font-family: ", ";\n    ", ";\n  "], ["\n    border-radius: ", ";\n    font-family: ", ";\n    ", ";\n  "])), rem(button['border-radius']), button['font-family'], button.css && button.css);
}, function (_a) {
  var disabled = _a.disabled;
  return disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: not-allowed;\n      opacity: 0.5;\n    "], ["\n      cursor: not-allowed;\n      opacity: 0.5;\n    "])));
}, getHeightStyle, getHorizontalPadding, getFontSize, getIconContainerSize);
var templateObject_1, templateObject_2, templateObject_3;